module.exports = __webpack_public_path__ + "static/install_progress-8c21d5e9c4913b2ac7cdd2b81e054d4a.png";